module.exports = __webpack_public_path__ + "img/hamrun-spartans-logo-icon.50269e63.png";